import request from "_private/utils/request";

/**
 * @description  对接日志信息列表接口
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findByPage(data) {
  return request({
    url: "/docking/dockingLog/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}
